import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import AccessDeny from './views/AccessDeny.vue'
import Logouted from './views/Logouted.vue'
import HomeGA from './views/HomeGA.vue'
import TrainingList from './views/Training/List.vue'
import TrainingApplyForm from './views/Training/ApplyForm.vue'
import TrainingAttendance from './views/Training/Attendance.vue'
import TrainingAttendanceDetail from './views/Training/AttendanceDetail.vue'
import SubsidyList from './views/Subsidy/List'
import MarrySubsidyApplyForm from './views/MarrySubsidy/ApplyForm.vue'
import BornSubsidyApplyForm from './views/BornSubsidy/ApplyForm.vue'
import TrainingTaskList from './views/Tasklist/TrainingList'
import TrainingTaskDetail from './views/Tasklist/TrainingDetail'
import TrainingStaffOrder from './views/Tasklist/TrainingStaffOrder'
import InternalProposalPage from './views/Tasklist/InternalProposalPage'
import TrainingHistory from './views/Tasklist/TrainingHistory'
// import GeneralList from './views/Tasklist/GeneralList'
// import GeneralListHistory from './views/Tasklist/GeneralListHistory'
import AttentionTrainingList from './views/Tasklist/AttentionTrainingList'
import AttentionGeneralList from './views/Tasklist/AttentionGeneralList'
import AttentionOutboxListHistory from './views/Tasklist/AttentionOutboxListHistory'
import AttentionTaskManage from './views/Tasklist/AttentionTaskManage'
import TaskListSetting from './views/Tasklist/Setting'
import OutboxList from './views/Tasklist/OutboxList'
import OutboxListHistory from './views/Tasklist/OutboxListHistory'
import OutboxGroupList from './views/Tasklist/OutboxGroupList'
import OutboxGroupListHistory from './views/Tasklist/OutboxGroupListHistory'
import GeneralGroupList from './views/Tasklist/GeneralGroupList'
import GeneralGroupListHistory from './views/Tasklist/GeneralGroupListHistory'
import EDocInternal from './views/Tasklist/EDocInternal'
import EDocInternalDetail from './views/Tasklist/EDocInternalDetail'
import EDocInternalHistory from './views/Tasklist/EDocInternalHistory'
import EDocInternalDetailHistory from './views/Tasklist/EDocInternalDetailHistory'
import EleaveList from './views/Eleave/List.vue'
import ReasonableLeave from './views/Eleave/ReasonableLeave.vue'
import AnnualLeave from './views/Eleave/AnnualLeave.vue'
import TransferLeave from './views/Eleave/TransferLeave.vue'
import SickLeaveList from './views/Eleave/SickLeaveList.vue'
import SickLeaveDetail from './views/Eleave/SickLeaveDetail.vue'
import ApprovedLeaveTable from './views/Eleave/ApprovedLeaveTable.vue'
import ApprovedAbsentTable from './views/Eleave/ApprovedAbsentTable.vue'
import ApprovedAbsentDetail from './views/Eleave/ApprovedAbsentDetail.vue'
import StaffSickList from './views/EleaveAdmin/StaffSickList.vue'
import StaffSickDetail from './views/EleaveAdmin/StaffSickDetail'
import HRPersonInfo from './views/HumanResources/PersonInfo.vue'
import HRTrainingInfo from './views/HumanResources/TrainingInfo.vue'
import HROtherInfo from './views/HumanResources/OtherInfo.vue'
import StaffEntityOfficial from './views/Contact/StaffEntityOfficial.vue'
import StaffEntityOfficialDetail from './views/Contact/StaffEntityOfficialDetail.vue'
import SignCallbackReceiver from './views/SignCallbackReceiver.vue'
import SignByStaffCodeCallbackReceiver from './views/SignByStaffCodeCallbackReceiver.vue'
import BwEsignCbReceiver from './views/BwEsignCbReceiver.vue'
import GeneralOpinion from './views/Box/GeneralOpinion.vue'
import DtjForm from './views/Inbox/Form.vue'
import submitSuccess from './views/Inbox/submitSuccess.vue'
import AttendanceView from './views/Attendance/View.vue'
import OtView from './views/Attendance/OT.vue'
import OutboxCreate from './views/Outbox/Create.vue'
import OutboxLite from './views/OutboxLite/Create.vue'
import WorkFlowList from './views/Workflow/List.vue'
import NotAllowed from './views/NotAllowed.vue'
import TrainingWorkflow from './views/Training/Workflow.vue'
import constant, { BUSINESS_CODE } from './constant/constant'
import store from './store'
import { workflowModule } from './store/moduleName'
import { workflow } from './store/modules/workflow/workflow'
import goTo from 'vuetify/es5/services/goto'
// import AwareList from './views/Tasklist/AwareList.vue'
// for testing
import InternalTesting from './views/InternalTesting.vue'
import Test from './views/Test.vue'
import PdfAnnotateTest from './views/Test/PdfAnnotateTest.vue'
import Tools from './views/Tools/Index.vue'
// import idSignAndCompleteCbReceiver from './views/IdSignAndCompleteCbReceiver.vue'

if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: constant.PUBLIC_PATH,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: process.env.VUE_APP_MODE === 'APP' || process.env.VUE_APP_MODE === 'PWA'
      }
    },
    {
      path: '/about',
      name: 'about'
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/accessDeny',
      name: 'accessDeny',
      component: AccessDeny
    },
    {
      path: '/logouted',
      name: 'logouted',
      component: Logouted
    },
    {
      path: '/ga-app',
      name: 'gaApp',
      component: HomeGA
    },
    {
      path: '/subsidy',
      name: 'subsidyList',
      component: SubsidyList,
      meta: {
        requiresAuth: true,
        perServices: [constant.PER_SERVICES.SUBSIDY]
      }
    },
    {
      path: '/marrySubsidy',
      name: 'marrySubsidy',
      redirect: '/marrySubsidy/applyForm',
      meta: {
        requiresAuth: true,
        perServices: [constant.PER_SERVICES.SUBSIDY]
      }
    },
    {
      path: '/marrySubsidy/applyForm',
      name: 'marrySubsidyApplyForm',
      component: MarrySubsidyApplyForm,
      meta: {
        requiresAuth: true,
        perServices: [constant.PER_SERVICES.SUBSIDY]
      }
    },
    {
      path: '/bornSubsidy',
      name: 'bornSubsidy',
      redirect: '/bornSubsidy/applyForm',
      meta: {
        requiresAuth: true,
        perServices: [constant.PER_SERVICES.SUBSIDY]
      }
    },
    {
      path: '/bornSubsidy/applyForm',
      name: 'bornSubsidyApplyForm',
      component: BornSubsidyApplyForm,
      meta: {
        requiresAuth: true,
        perServices: [constant.PER_SERVICES.SUBSIDY]
      }
    },
    // {
    //   path: '/training',
    //   redirect: '/training/list',
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.TRAINING]
    //   }
    // },
    // {
    //   path: '/training/list',
    //   name: 'trainingList',
    //   component: TrainingList,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.TRAINING]
    //   }
    // },
    // {
    //   path: '/training/applyForm/:courseId',
    //   name: 'training/applyForm',
    //   component: TrainingApplyForm,
    //   props: true,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.TRAINING]
    //   }
    // },
    // {
    //   path: '/training/workflow',
    //   name: 'training/workflow',
    //   component: TrainingWorkflow,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.TRAINING]
    //   }
    // },
    // {
    //   path: '/training/attendance',
    //   name: 'training/attendance',
    //   component: TrainingAttendance,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.TRAINING]
    //   }
    // },
    // {
    //   path: '/training/attendanceDetail/:courseId',
    //   name: 'training/attendanceDetail',
    //   component: TrainingAttendanceDetail,
    //   props: true,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.TRAINING]
    //   }
    // },
    {
      path: '/tasklist/index',
      redirect: '/tasklist/'
    },
    {
      path: '/tasklist',
      beforeEnter: async (from, to, next) => {
        await store.dispatch(workflowModule + '/countBwItems')
        await store.dispatch(workflowModule + '/countPersonalItems')
        let items = store.state[workflowModule].items
        let isAllJobEmpty = true
        for (const item of items) {
          for (const subItem of item.subItems) {
            if (subItem.jobNum > 0) {
              isAllJobEmpty = false
              next(subItem.url)
              break
            }
          }
          if (isAllJobEmpty === false) {
            break
          }
        }
        if (isAllJobEmpty) {
          next(items[0].subItems[0].url)
        }
      },
      // redirect: '/tasklist/trainingList',
      name: 'tasklist',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/trainingList',
      name: 'tasklist/trainingList',
      component: TrainingTaskList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/trainingDetail/:courseId',
      name: 'tasklist/trainingDetail',
      component: TrainingTaskDetail,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/trainingStaffOrder/:courseId',
      name: 'tasklist/trainingStaffOrder',
      component: TrainingStaffOrder,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/trainingHistory',
      name: 'tasklist/trainingHistory',
      component: TrainingHistory,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/InternalProposalPage/',
      name: '/tasklist/InternalProposalPage',
      component: InternalProposalPage,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/tasklist/generalList/:businessCode',
    //   name: 'tasklist/generalList',
    //   props: true,
    //   component: GeneralList,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/tasklist/generalListHistory',
    //   name: 'tasklist/generalListHistory',
    //   // props: true,
    //   component: GeneralListHistory,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/tasklist/attentionGeneralList/:businessCode/:attentionStaffEuid?',
      name: 'tasklist/attentionGeneralList',
      props: true,
      component: AttentionGeneralList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/attentionOutboxListHistory/:attentionStaffEuid',
      name: 'tasklist/attentionOutboxListHistory',
      props: true,
      component: AttentionOutboxListHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/attentionESignListHistory/:attentionStaffEuid',
      name: 'tasklist/attentionESignListHistory',
      props: (route) => {
        return {
          businessCode: BUSINESS_CODE.ESIGN,
          attentionStaffEuid: route.params.attentionStaffEuid
        }
      },
      component: AttentionOutboxListHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/attentionTaskManage/',
      name: 'tasklist/attentionTaskManage',
      component: AttentionTaskManage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/attentionEDocInt/:attentionStaffEuid?',
      name: 'tasklist/attentionEDocInt',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/AttentionEDocInt'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/attentionEDocIntDetail/:attentionStaffEuid/:processId',
      name: 'tasklist/attentionEDocIntDetail',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/AttentionEDocIntDetail'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/attentionEDocIntHistory/:attentionStaffEuid?',
      name: 'tasklist/attentionEDocIntHistory',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/AttentionEDocIntHistory'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/attentionEDocIntDetailHistory/:attentionStaffEuid/:processId',
      name: 'tasklist/attentionEDocIntDetailHistory',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/AttentionEDocIntDetailHistory.vue'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/setting/',
      name: 'tasklist/setting',
      component: TaskListSetting,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/attentionTrainingList/',
      name: 'tasklist/attentionTrainingList',
      component: AttentionTrainingList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/outboxList',
      name: 'tasklist/outboxList',
      component: OutboxList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/eSignList',
      name: 'tasklist/eSignList',
      props: {
        businessCode: BUSINESS_CODE.ESIGN
      },
      component: OutboxList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/eSignListHistory',
      name: 'tasklist/eSignListHistory',
      props: {
        businessCode: BUSINESS_CODE.ESIGN
      },
      component: OutboxListHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/outboxListHistory',
      name: 'tasklist/outboxListHistory',
      component: OutboxListHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/outboxGroupList/:groupId?',
      name: 'tasklist/outboxGroupList',
      props: true,
      component: OutboxGroupList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/generalGroupList/:businessCode/:groupId?',
      name: 'tasklist/generalGroupList',
      props: (route) => {
        return {
          businessCode: route.params.businessCode,
          groupId: route.params.groupId
        }
      },
      component: GeneralGroupList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/generalGroupListHistory/:businessCode/:groupId?',
      name: 'tasklist/generalGroupListHistory',
      props: (route) => {
        return {
          businessCode: route.params.businessCode,
          groupId: route.params.groupId
        }
      },
      component: GeneralGroupListHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/eSignGroupList/:groupId?',
      name: 'tasklist/eSignGroupList',
      props: (route) => {
        return {
          businessCode: BUSINESS_CODE.ESIGN,
          groupId: route.params.groupId
        }
      },
      component: OutboxGroupList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/outboxGroupListHistory/:groupId?',
      name: 'tasklist/outboxGroupListHistory',
      props: true,
      component: OutboxGroupListHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/eSignGroupListHistory/:groupId?',
      name: 'tasklist/eSignGroupListHistory',
      props: (route) => {
        return {
          businessCode: BUSINESS_CODE.ESIGN,
          groupId: route.params.groupId
        }
      },
      component: OutboxGroupListHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/eDocInternal',
      name: 'tasklist/eDocInternal',
      props: true,
      component: EDocInternal,
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocInternalDetail/:processId',
      name: 'tasklist/eDocInternalDetail',
      props: true,
      component: EDocInternalDetail,
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocInternalHistory',
      name: 'tasklist/eDocInternalHistory',
      component: EDocInternalHistory,
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocInternalDetailHistory/:processId',
      name: 'tasklist/eDocInternalDetailHistory',
      props: true,
      component: EDocInternalDetailHistory,
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocSuggest',
      name: 'tasklist/eDocSuggest',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/EDocSuggest'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocSugGroup/:groupId?',
      name: 'tasklist/eDocSugGroup',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/EDocSuggestGroup'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/attentionEDocSuggest/:attentionStaffEuid?',
      name: 'tasklist/attentionEDocSuggest',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/AttentionEDocSuggest'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocSuggestHistory',
      name: 'tasklist/eDocSuggestHistory',
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/EDocSuggestHistory'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocSugGroupHistory/:groupId?',
      name: 'tasklist/eDocSugGroupHistory',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/EDocSuggestGroupHistory'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/attentionEDocSuggestHistory/:attentionStaffEuid?',
      name: 'tasklist/attentionEDocSuggestHistory',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/AttentionEDocSuggestHistory'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    // {
    //   path: '/tasklist/eDocInternalDemo',
    //   name: 'tasklist/eDocInternalDemo',
    //   component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/EDocInternalDemo'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/tasklist/eDocInternalHistoryDemo',
    //   name: 'tasklist/eDocInternalHistoryDemo',
    //   component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/EDocInternalHistoryDemo'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/tasklist/awareList/:businessCode',
      name: 'tasklist/awareList',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/AwareList'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/eDocInternal/Search',
      name: '/eDocInternal/Search',
      component: () => import(/* webpackChunkName: "eDocInternal" */ './views/eDocInternal/Search'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/eDocInternal/DocDetail/:inflowId/:searchType',
      name: '/eDocInternal/DocDetail',
      component: () => import(/* webpackChunkName: "eDocInternal" */ './views/eDocInternal/DocDetail'),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/eDocInternal/SearchD',
    //   name: '/eDocInternal/SearchDemo',
    //   component: () => import(/* webpackChunkName: "eDocInternal" */ './views/eDocInternal/SearchDemo'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/eDocInternal/DocDetailD/:docId',
    //   name: '/eDocInternal/DocDetailDemo',
    //   component: () => import(/* webpackChunkName: "eDocInternal" */ './views/eDocInternal/DocDetailDemo'),
    //   props: true,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/eDocInternal/Create',
      name: '/eDocInternal/Create',
      component: () => import(/* webpackChunkName: "eDocInternal" */ './views/eDocInternal/Create'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/eDocIntGroup/:groupId?',
      name: 'tasklist/eDocIntGroup',
      props: true,
      component: () => import(/* webpackChunkName: "eDocInternal" */ './views/Tasklist/EDocIntGroup'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocIntGroupDetail/:groupId/:processId',
      name: 'tasklist/eDocIntGroupDetail',
      props: true,
      component: () => import(/* webpackChunkName: "eDocInternal" */ './views/Tasklist/EDocIntGroupDetail'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocIntGroupHistory/:groupId?',
      name: 'tasklist/eDocIntGroupHistory',
      props: true,
      component: () => import(/* webpackChunkName: "eDocInternal" */ './views/Tasklist/EDocIntGroupHistory'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    {
      path: '/tasklist/eDocIntGroupDetailHistory/:groupId/:processId',
      name: 'tasklist/eDocIntGroupDetailHistory',
      props: true,
      component: () => import(/* webpackChunkName: "eDocInternal" */ './views/Tasklist/EDocIntGroupDetailHistory'),
      meta: {
        requiresAuth: true
        // perServices: [constant.PER_SERVICES.EDOC_TRANSMIT]
      }
    },
    // {
    //   path: '/eleave',
    //   redirect: '/eleave/list',
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/eleave/list',
    //   name: 'eleaveList',
    //   component: EleaveList,
    //   beforeEnter: async (from, to, next) => {
    //     let hasEleaveOrPaperLeave = router.app.$perServices.hasServices([constant.PER_SERVICES.ELEAVE, constant.PER_SERVICES.PAPER_LEAVE])
    //     let hasSickLeave = router.app.$perServices.hasServices([constant.PER_SERVICES.SICK_LEAVE])
    //     if (hasEleaveOrPaperLeave) {
    //       next()
    //     } else if (hasSickLeave) {
    //       next('/eleave/SickLeaveList')
    //     }
    //   },
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE, constant.PER_SERVICES.PAPER_LEAVE, constant.PER_SERVICES.SICK_LEAVE]
    //   }
    // },
    // {
    //   path: '/eleave/ReasonableLeave',
    //   name: 'reasonableLeave',
    //   component: ReasonableLeave,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE]
    //   }
    // },
    // {
    //   path: '/eleave/AnnualLeave',
    //   name: 'annualLeave',
    //   component: AnnualLeave,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE]
    //   }
    // },
    // {
    //   path: '/eleave/TransferLeave',
    //   name: 'transferLeave',
    //   component: TransferLeave,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE]
    //   }
    // },
    // {
    //   path: '/eleave/SickLeaveList',
    //   name: 'sickLeaveList',
    //   component: SickLeaveList,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.SICK_LEAVE]
    //   }
    // },
    // {
    //   path: '/eleave/SickLeaveDetail',
    //   name: 'sickLeaveDetail',
    //   component: SickLeaveDetail,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.SICK_LEAVE]
    //   }
    // },
    // {
    //   path: '/eleave/NoLongLeave',
    //   name: 'noLongLeave',
    //   component: () => import(/* webpackChunkName: "mapa" */ './views/Eleave/NoLongLeave.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE]
    //   }
    // },
    // {
    //   path: '/eleave/ApprovedLeaveTable',
    //   name: 'ApprovedLeaveTable',
    //   component: ApprovedLeaveTable,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE, constant.PER_SERVICES.PAPER_LEAVE]
    //   }
    // },
    // {
    //   path: '/eleave/ApprovedAbsentTable',
    //   name: 'ApprovedAbsentTable',
    //   component: ApprovedAbsentTable,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE, constant.PER_SERVICES.PAPER_LEAVE]
    //   }
    // },
    // {
    //   path: '/eleave/ApprovedAbsentDetail',
    //   name: 'ApprovedAbsentDetail',
    //   props: true,
    //   component: ApprovedAbsentDetail,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE, constant.PER_SERVICES.PAPER_LEAVE]
    //   }
    // },
    // {
    //   path: '/mapa',
    //   redirect: '/mapa/MapaIndex',
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/mapa/Mapa/:yearProp',
    //   name: 'Mapa',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "mapa" */ './views/Mapa/Mapa.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE]
    //   }
    // },
    // {
    //   path: '/mapa/ViewStaff/:entityId?',
    //   name: 'MapaViewStaff',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "mapa" */ './views/Mapa/ViewStaff.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perFunctions: [constant.PER_FUNCTIONS.LEAVE_MARK_SUBUNIT, constant.PER_FUNCTIONS.LEAVE_MARK_ADM]
    //   }
    // },
    // {
    //   path: '/mapa/ViewStaffYear/:entityId?',
    //   name: 'MapaViewStaffYear',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "mapa" */ './views/Mapa/ViewStaffYear.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perFunctions: [constant.PER_FUNCTIONS.LEAVE_MARK_SUBUNIT, constant.PER_FUNCTIONS.LEAVE_MARK_ADM]
    //   }
    // },
    // {
    //   path: '/mapa/MapaIndex',
    //   name: 'MapaIndex',
    //   component: () => import(/* webpackChunkName: "mapa" */ './views/Mapa/MapaIndex.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/eleaveAdmin/StaffSickList',
    //   name: 'staffSickList',
    //   component: StaffSickList,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE]
    //   }
    // },
    // {
    //   path: '/eleaveAdmin/StaffSickDetail',
    //   name: 'staffSickDetail',
    //   component: StaffSickDetail,
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE]
    //   }
    // },
    // {
    //   path: '/humanResources',
    //   redirect: '/humanResources/PersonInfo',
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/humanResources/PersonInfo',
    //   name: 'HRPersonInfo',
    //   component: HRPersonInfo,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/humanResources/TrainingInfo',
    //   name: 'HRTrainingInfo',
    //   component: HRTrainingInfo,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/humanResources/OtherInfo',
    //   name: 'HROtherInfo',
    //   component: HROtherInfo,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH',
    //   redirect: '/BDRH/Index',
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH/Index',
    //   name: 'BdrhIndex',
    //   component: () => import(/* webpackChunkName: "bdrh" */ './views/BDRH/Index.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH/SexAndAge',
    //   name: 'BdrhSexAndAge',
    //   component: () => import(/* webpackChunkName: "bdrh" */ './views/BDRH/SexAndAge.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH/Contract',
    //   name: 'BdrhContract',
    //   component: () => import(/* webpackChunkName: "bdrh" */ './views/BDRH/Contract.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH/Education',
    //   name: 'BdrhEducation',
    //   component: () => import(/* webpackChunkName: "bdrh" */ './views/BDRH/Education.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH/Department',
    //   name: 'BdrhDepartment',
    //   component: () => import(/* webpackChunkName: "bdrh" */ './views/BDRH/Department.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH/Indices',
    //   name: 'BdrhIndices',
    //   component: () => import(/* webpackChunkName: "bdrh" */ './views/BDRH/Indices.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH/BirthPlace',
    //   name: 'BdrhBirthPlace',
    //   component: () => import(/* webpackChunkName: "bdrh" */ './views/BDRH/BirthPlace.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH/Language',
    //   name: 'BdrhLanguage',
    //   component: () => import(/* webpackChunkName: "bdrh" */ './views/BDRH/Language.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/BDRH/MotherLang',
    //   name: 'BdrhMotherLang',
    //   component: () => import(/* webpackChunkName: "bdrh" */ './views/BDRH/MotherLang.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/contact/StaffEntityOfficial',
      name: 'StaffEntityOfficial',
      component: StaffEntityOfficial,
      meta: {
        requiresAuth: true,
        perServices: [constant.PER_SERVICES.SUBSTITUTE]
      }
    },
    {
      path: '/contact/StaffEntityOfficialDetail',
      name: 'StaffEntityOfficialDetail',
      props: true,
      component: StaffEntityOfficialDetail,
      meta: {
        requiresAuth: true,
        perServices: [constant.PER_SERVICES.SUBSTITUTE]
      }
    },
    {
      path: '/signCbReceiver',
      name: 'SignCbReceiver',
      component: SignCallbackReceiver,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/signByStaffCbReceiver',
      name: 'SignByStaffCbReceiver',
      component: SignByStaffCodeCallbackReceiver,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bwEsignCbReceiver',
      name: 'BwEsignCbReceiver',
      component: BwEsignCbReceiver,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/idSignAndDownloadPdfCbReceiver',
      name: 'IdSignAndDownloadPdfCbReceiver',
      component: () => import(/* webpackChunkName: "bdrh" */ './views/IdSignAndDownloadPdfCbReceiver.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/idSignAndCompleteCbReceiver',
      name: 'IdSignAndCompleteCbReceiver',
      component: () => import(/* webpackChunkName: "bdrh" */ './views/IdSignAndCompleteCbReceiver.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/idSignBatchCbReceiver',
      name: 'IdSignBatchCbReceiver',
      component: () => import(/* webpackChunkName: "bdrh" */ './views/IdSignBatchCbReceiver.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/box/GeneralOpinion',
      name: 'GeneralOpinion',
      component: GeneralOpinion,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inbox/dtjform',
      name: 'DtjForm',
      component: DtjForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inbox/submitSuccess',
      name: 'submitSuccess',
      component: submitSuccess,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/attendance/View',
      name: 'AttendanceView',
      component: AttendanceView,
      meta: {
        requiresAuth: true,
        perServices: [constant.PER_SERVICES.ATTENDANCE]
      }
    },
    {
      path: '/attendance/OT',
      name: 'OtView',
      component: OtView,
      meta: {
        requiresAuth: true,
        perServices: [constant.PER_SERVICES.OVERTIME]
      }
    },
    // {
    //   path: '/outbox',
    //   redirect: '/outbox/Create',
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/outbox/Create',
    //   name: 'OutboxCreate',
    //   component: OutboxCreate,
    //   props: (route) => ({
    //     ...route.params
    //   }),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/outboxLite',
      redirect: '/outboxLite/Create',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/outboxLite/Create',
      name: 'OutboxLite',
      component: OutboxLite,
      props: {
        businessCode: BUSINESS_CODE.OFICIO
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/eSign',
      redirect: '/eSign/Create',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/eSign/Create',
      name: 'eSign/Create',
      component: OutboxLite,
      props: {
        businessCode: BUSINESS_CODE.ESIGN
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/workflow/List',
      name: 'WorkFlowList',
      component: WorkFlowList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/idGeneralList/:businessCode',
      name: 'tasklist/idGeneralList',
      props: true,
      component: () => import(/* webpackChunkName: "bdrh" */ './views/Tasklist/IdGeneralList.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/idGeneralListHistory/:businessCode',
      name: 'tasklist/idGeneralListHistory',
      props: true,
      component: () => import(/* webpackChunkName: "bdrh" */ './views/Tasklist/IdGeneralListHistory.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/redirect/:permission',
      name: 'redirectN',
      props: true,
      component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/General.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/redirectContacts',
      name: 'redirectContacts',
      component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/Contacts.vue'),
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/redirect/attendance',
    //   name: 'redirectAttendance',
    //   component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/General.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ATTENDANCE]
    //   }
    // },
    // {
    //   path: '/redirect/eleave',
    //   name: 'redirectEleave',
    //   component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/General.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.ELEAVE]
    //   }
    // },
    // {
    //   path: '/redirect/paperEleave',
    //   name: 'redirectPaperEleave',
    //   component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/General.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.PAPER_LEAVE]
    //   }
    // },
    // {
    //   path: '/redirect/training',
    //   name: 'redirectTraining',
    //   component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/General.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.TRAINING]
    //   }
    // },
    // {
    //   path: '/redirect/sickLeave',
    //   name: 'redirectSickLeave',
    //   component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/General.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.SICK_LEAVE]
    //   }
    // },
    // {
    //   path: '/redirect/overtime',
    //   name: 'redirectOvertime',
    //   component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/General.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.OVERTIME]
    //   }
    // },
    // {
    //   path: '/redirect/contacts',
    //   name: 'redirectContacts',
    //   component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/General.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     perServices: [constant.PER_SERVICES.CONTACTS]
    //   }
    // },
    // {
    //   path: '/redirect/informac',
    //   name: 'redirectInformac',
    //   component: () => import(/* webpackChunkName: "redirect" */ './views/Redirect/Informac.vue')
    //   // meta: {
    //   //   requiresAuth: true
    //   // }
    // },
    {
      path: '/notAllowed/:reasonType',
      name: 'NotAllowed',
      component: NotAllowed,
      props: true
    },
    {
      path: '/tools/index',
      name: 'tools',
      component: Tools,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/mcList',
      name: 'tasklist/mcList',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/MCList'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/mcListHistory',
      name: 'tasklist/mcListHistory',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/MCListHistory'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/mcGroupList/:groupId?',
      name: 'tasklist/mcGroupList',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/MCGroupList'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/mcGroupListHistory/:groupId?',
      name: 'tasklist/mcGroupListHistory',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/MCGroupListHistory'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/attentionMcList',
      name: 'tasklist/attentionMcList',
      props: true,
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Tasklist/AttentionMCList'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/bwGeneralList/:businessCode',
      name: 'tasklist/bwGeneralList',
      props: true,
      component: () => import(/* webpackChunkName: "bdrh" */ './views/Tasklist/BwGeneralList.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/bwGeneralListHistory/:businessCode',
      name: 'tasklist/bwGeneralListHistory',
      props: true,
      component: () => import(/* webpackChunkName: "bdrh" */ './views/Tasklist/BwGeneralListHistory.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/bwAttentionGeneralList/:businessCode/:attentionStaffEuid?',
      name: 'tasklist/bwAttentionGeneralList',
      props: true,
      component: () => import(/* webpackChunkName: "bdrh" */ './views/Tasklist/BwAttentionGeneralList.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasklist/bwAttentionGeneralListHistory/:businessCode/:attentionStaffEuid?',
      name: 'tasklist/bwAttentionGeneralListHistory',
      props: true,
      component: () => import(/* webpackChunkName: "bdrh" */ './views/Tasklist/BwAttentionGeneralListHistory.vue'),
      meta: {
        requiresAuth: true
      }
    },
    // for testing
    {
      path: '/internalTesting',
      name: 'internalTesting',
      component: InternalTesting
    },
    {
      path: '/needPermission',
      name: 'needPermission',
      component: Test,
      meta: {
        perServices: [constant.PER_SERVICES.SUBSIDY],
        perFunctions: ['constant.PER_FUNCTIONS.SUBSIDY_ADM']
      }
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/pdfAnnotateTest',
      name: 'PdfAnnotateTest',
      component: PdfAnnotateTest
    },
    {
      path: '/test/idVerification',
      name: 'IdVerification',
      component: () => import(/* webpackChunkName: "tasklist" */ './views/Test/IdVerification.vue')
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  let passed = await router.app.$g2eOauth.routeGuardCheckAuth(to, from, next)
  if (passed) {
    if (!router.app.$perServices.routeCheck(to)) {
      next(`/notAllowed/${constant.NOT_ALLOWED_REASON.NO_SERVICE}`)
    } else if (!router.app.$perFunctions.routeCheck(to)) {
      next(`/notAllowed/${constant.NOT_ALLOWED_REASON.NO_FUNCTION}`)
    } else {
      next()
    }
  }
})

export default router
